//用户管理
const ParkingUser = () => import(/*webpackChunkName:'system'*/'@/page/system/userManager/user.vue')//用户
// import ParkingScope from '../page/userManager/scope.vue'
const ParkingGroup = () => import(/*webpackChunkName:'system'*/'@/page/system/userManager/group.vue')//角色

const SystemLayOut = () => import(/*webpackChunkName:'system'*/'@/page/system/systemLayOut.vue')

import { log } from './modules/log'

import {activeConfiguration} from "./modules/activeConfiguration"

export const system={
    path:'/system',
    name:'系统设置',
    component:SystemLayOut,
    redirect:'/main/log/conLog',
    children:[
        log,
        activeConfiguration,
        {
            path: '/admin/user',
            // path: '/main/admin/userList',
            name: '用户管理',
            meta: {
                requireAuth: true,
            },
            component: ParkingUser
        },
        {
            path: '/main/parking/admin/group',
            name: '角色管理',
            meta: {
                requireAuth: true,

            },
            component: ParkingGroup
        }
    ]
}